import { Icon } from '@aibees/shared/components';
import { fHumanReadableNumber } from '@aibees/shared/utils';
import { Box, MenuItem, Select, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import { usePlanCardContext } from '../../context';
import * as SX from './sx';

const MENU_PROPS = {
  anchorOrigin: {
    vertical: 'bottom' as const,
    horizontal: 'left' as const,
  },
  transformOrigin: {
    vertical: 'top' as const,
    horizontal: 'left' as const,
  },
  PaperProps: {
    sx: SX.paper,
  },
};

export const CreditSelect = memo(() => {
  const {
    yearly,
    currentPlan,
    handleSelectPlan,
    options,
    isPaid,
    selectedPlan,
    isLoading,
  } = usePlanCardContext();

  const userCurrentPlanId = currentPlan?.id;

  return (
    <Select
      value={selectedPlan?.id ?? ''}
      defaultValue={selectedPlan?.id ?? ''}
      onChange={handleSelectPlan}
      size="small"
      sx={{ mt: 1.5 }}
      MenuProps={MENU_PROPS}
      renderValue={(selected) => {
        return (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            width="100%"
          >
            <Typography variant="body3" color="grey.600" fontWeight={700}>
              {fHumanReadableNumber(Number(selectedPlan?.metadata.request))}{' '}
              Credits / {isPaid && yearly ? 'Year' : 'Month'}
            </Typography>
            {userCurrentPlanId === selected && (
              <Icon
                name="check-circle-outline-rounded"
                size={18}
                color="success.500"
              />
            )}
          </Stack>
        );
      }}
      disabled={!isPaid || isLoading}
    >
      {options &&
        options.map((option, index) => (
          <MenuItem
            key={index}
            value={option.id}
            sx={SX.menuItem}
            selected={userCurrentPlanId === option.id}
          >
            <Stack direction="row" alignItems="center" gap={0.5}>
              <Icon name="coin" size={16} color="grey.700" />
              <Typography variant="body4" color="grey.700">
                {fHumanReadableNumber(Number(option.value))} Credits
              </Typography>
              {!isPaid && (
                <Typography variant="body4" color="grey.400">
                  {' '}
                  / Month
                </Typography>
              )}
              {isPaid && (
                <Typography variant="body4" color="grey.400">
                  / {yearly ? 'Year' : 'Month'}
                </Typography>
              )}
            </Stack>
            <Box display="flex" alignItems="center" gap={1}>
              {userCurrentPlanId === option.id && (
                <Icon name="check-circle-outline-rounded" color="success.500" />
              )}
            </Box>
          </MenuItem>
        ))}
    </Select>
  );
});

CreditSelect.displayName = 'CreditSelect';
